const DEFAULT_SCORING = {
  challengeWinner: 100,
  challengeLoser: 50,
  achievements: {},
};

async function readConfig(url) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 6000);
  try {
    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    });
    const data = await response.json().catch(() => null);
    if (!response.ok || !data?.config) throw new Error('Configuración no disponible.');
    return data.config;
  } finally {
    clearTimeout(timeout);
  }
}

export async function fetchScoringGuide() {
  const [scoring, hiddenPoints] = await Promise.allSettled([
    readConfig('/api/config/scoring'),
    readConfig('/api/config/hidden-points'),
  ]);
  return {
    scoring: scoring.status === 'fulfilled' ? scoring.value : DEFAULT_SCORING,
    hiddenPoints: hiddenPoints.status === 'fulfilled' ? hiddenPoints.value : { pointsPerFind: 10 },
  };
}
